import * as Sentry from '@sentry/react';
import { Box, Button, Card, CardContent, Typography, Stack } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * Sentry ile hata yakalayan, destek için olay kimliği gösteren sınır bileşeni.
 *
 * @param {{ children: import('react').ReactNode }} props
 */
function SentryErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, eventId, resetError }) => (
        <Box
          sx={{
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
            bgcolor: 'background.default',
          }}
        >
          <Card elevation={4} sx={{ maxWidth: 480, width: '100%' }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h5" component="h1" gutterBottom color="error">
                Bir şeyler ters gitti
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Sayfa beklenmedik bir hata verdi. Sorun kayıt altına alındı. Destek ekibine başvururken aşağıdaki
                referans numarasını iletebilirsiniz.
              </Typography>
              {eventId ? (
                <Typography
                  variant="caption"
                  component="pre"
                  sx={{
                    display: 'block',
                    p: 1.5,
                    bgcolor: 'action.hover',
                    borderRadius: 1,
                    fontFamily: 'monospace',
                    wordBreak: 'break-all',
                    mb: 2,
                  }}
                >
                  Olay ID: {eventId}
                </Typography>
              ) : null}
              {error && typeof error === 'object' && 'message' in error ? (
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  {String(error.message)}
                </Typography>
              ) : null}
              <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button variant="contained" startIcon={<RefreshIcon />} onClick={resetError} color="primary">
                  Yenile
                </Button>
              </Stack>
            </CardContent>
          </Card>
        </Box>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default SentryErrorBoundary;
